import TokenManager from "utils/TokenManager";
import englishTranslation from "utils/localization/locale_en.json";
import disputeReducer from "containers/disputeDeduction/reducer";
import { ReducersTypes } from "../constants/ReducersTypes";

const initconfirmationbox = {
  ...{
    msg: "",
    variant: "info", // "success", "error", "warning", "info",
    onSave: null,
  },
};

const confirmationbox = (state = initconfirmationbox, action) => {
  switch (action.type) {
    case ReducersTypes.CONFIRMATION_BOX:
      return { ...state, ...action.payload };
    case ReducersTypes.CONFIRMATION_BOX_RESET:
      return initconfirmationbox;
    default:
      return state;
  }
};

const initux = {};

const ux = (state = initux, action) => {
  switch (action.type) {
    case ReducersTypes.SET_UX:
      return { ...state, ...action.payload };
    case ReducersTypes.RESET_UX:
      return initux;
    default:
      return state;
  }
};

const initemail = {
  ...{
    show: false,
    from: "",
    to: "",
    cc: TokenManager.getUserEmail(),
    subject: "",
    body: "",
    emailTemplateData: [],
    customerVendorName: "",
    files: [],
    skip_attachments: false,
    attachments_skipped: false,
    showCC: true,
  },
};

const email = (state = initemail, action) => {
  switch (action.type) {
    case ReducersTypes.EMAIL_DATA:
      return { ...state, ...action.payload };
    case ReducersTypes.EMAIL_RESET:
      return initemail;
    default:
      return state;
  }
};

export const dynamicformReducer = (
  state = {
    forms: [],
    count: 0,
  },
  action
) => {
  switch (action.type) {
    case ReducersTypes.DYNAMIC_FORM:
      return { ...state, forms: action.payload.forms };
    case ReducersTypes.ADD_DYNAMIC_FORM:
      return {
        ...state,
        forms: [...state.forms, ...action.payload.forms],
        count: state.count + 1,
      };
    default:
      return state;
  }
};

const initpreview = {
  show: false,
  type: "", // doc, policy, info
  data: "",
  name: "",
  isbase64: false,
  ext: "",
  uri: "",
};

export const preview = (state = initpreview, action) => {
  switch (action.type) {
    case ReducersTypes.PREVIEW_DOCUMENT:
      return { ...state, ...action.payload };
    case ReducersTypes.RESET_PREVIEW_DOCUMENT:
      return { ...initpreview };
    default:
      return state;
  }
};

const initheader = {
  refresh_header: false,
};

export const header = (state = initheader, action) => {
  switch (action.type) {
    case ReducersTypes.HEADER:
      return { ...state, ...action.payload };
    case ReducersTypes.RESET_HEADER:
      return { ...initheader };
    case ReducersTypes.HEADER_REFRESH_TOGGLE:
      return { ...state, refresh_header: state.refresh_header ? false : true };
    default:
      return state;
  }
};

const applicationAnnouncement = (state = null, action) => {
  if (action.type === ReducersTypes.SET_ACTIVE_APPLICATION_ANNOUNCEMENT) {
    return action.payload;
  }
  return state;
};

const inittag = {
  allTags: "",
};

const tag = (state = inittag, action) => {
  switch (action.type) {
    case ReducersTypes.SET_TAG:
      return { ...state, ...action.payload };
    case ReducersTypes.RESET_TAG:
      return { ...inittag };
    default:
      return state;
  }
};

const workflow_sequence = (state = { workflows: [] }, action) => {
  switch (action.type) {
    case ReducersTypes.SET_WORKFLOW_SEQUENCE:
      return { ...state, ...action.payload };
    case ReducersTypes.RESET_WORKFLOW_SEQUENCE:
      return { ...inittag };
    default:
      return state;
  }
};

const client = {
  clientData: {},
  initialClientData: {},
  isFetching: false,
  currentDeletingCurrencyItems: [],
  aiCurrentAssignments: null,
  plansList: [],
};

const clientDetails = (state = client, action) => {
  switch (action.type) {
    case ReducersTypes.SET_AI_TOKEN_PLANS:
      return { ...state, plansList: action.payload };
    case ReducersTypes.SET_AI_CLIENT_TOKEN_ASSIGNMENTS:
      return { ...state, aiCurrentAssignments: action.payload };
    case ReducersTypes.UPDATE_AI_CLIENT_TOKEN_ASSIGNMENTS:
      return {
        ...state,
        aiCurrentAssignments: {
          ...state.aiCurrentAssignments,
          ...action.payload,
        },
      };
    case ReducersTypes.SAVE_AI_TOKEN_PLAN: {
      const plan = action.payload ?? {};
      const plansList = state.plansList ?? [];
      return {
        ...state,
        plansList: [...plansList, plan],
      };
    }
    case ReducersTypes.ASSIGN_TOKEN_PLAN_TO_CLIENT: {
      return {
        ...state,
        aiCurrentAssignments: action.payload,
      };
    }
    case ReducersTypes.FETCH_CLIENT_DATA: {
      const { clientData, initialClientData, isFetching } = action.payload;
      //
      let clientDataCopy = { ...state.clientData };
      const copyClientSettings = { ...(clientDataCopy?.client_settings || {}) };

      const updatedCopyClientSettings = {
        ...copyClientSettings,
        ...(clientData?.client_settings || {}),
      };

      clientDataCopy.client_settings = updatedCopyClientSettings;
      delete clientData?.client_settings;
      clientDataCopy = {
        ...clientDataCopy,
        ...clientData,
      };

      return {
        ...state,
        clientData: clientDataCopy,
        initialClientData,
        isFetching,
      };
    }
    case ReducersTypes.UPDATE_CLIENT_DATA:
      return initux;
    case ReducersTypes.UPDATE_DISCOUNT_STATE:
      return {
        ...state,
        clientData: {
          ...state.clientData,
          client_settings: {
            ...state.clientData.client_settings,
            ...action.payload,
          },
        },
      };
    case ReducersTypes.LOADING_CURRENCY_MAX_AMOUNTS: {
      return {
        ...state,
        clientData: {
          ...state.clientData,
          client_settings: {
            ...state.clientData.client_settings,
            loading_currency_max_amounts: action.payload,
          },
        },
      };
    }
    case ReducersTypes.FETCH_CURRENCY_MAX_AMOUNTS_SUCCESS: {
      return {
        ...state,
        clientData: {
          ...state.clientData,
          client_settings: {
            ...state.clientData.client_settings,
            currency_max_amounts: action.payload,
            loading_currency_max_amounts: false,
          },
        },
      };
    }

    case ReducersTypes.DELETING_CURRENCY_MAX_AMOUNTS_ADD: {
      return {
        ...state,
        currentDeletingCurrencyItems: [
          ...(state?.currentDeletingCurrencyItems || []),
          action.payload,
        ],
      };
    }
    case ReducersTypes.DELETING_CURRENCY_MAX_AMOUNTS_REMOVE: {
      return {
        ...state,
        currentDeletingCurrencyItems:
          state?.currentDeletingCurrencyItems?.filter(
            (item) => item !== action.payload
          ),
      };
    }
    case ReducersTypes.HELP_LINK: {
      const { description, url, id } = action.payload;
      return {
        ...state,
        clientData: {
          ...state.clientData,
          client_settings: {
            ...state.clientData.client_settings,
            help_doc_url: url,
            help_doc_label: description,
            help_doc_id: id,
          },
        },
      };
    }
    default:
      return state;
  }
};

const payrollSetting = {
  payrollSettings: [],
  isFetching: false,
};

const payrollSettingsData = (state = payrollSetting, action) => {
  switch (action.type) {
    case ReducersTypes.PAYROLL_SETTINGS_FETCH:
      return { ...state, ...action.payload };
    case ReducersTypes.PAYROLL_SETTINGS_UPDATE:
      return state;
    default:
      return state;
  }
};

export const initialConfigSettings = {
  customerSettings: {
    CUSTOMER_SHOW_DISPUTE_BUTTON: 0,
    CUSTOMER_SHOW_UNAPPLIED_PAYMENT: 0,
    CUSTOMER_SHOW_UNAPPLIED_CREDIT_MEMO: 0,
    CUSTOMER_SHOW_PAYFERENCE_PAYMENTS: 0,
    CUSTOMER_SHOW_ORDER_BACKLOG: 0,
    CUSTOMER_SHOW_DEPOSITS: 0,
    CUSTOMER_DSO_PERIOD: 0,
    CUSTOMER_RECEIVABLE_HISTORY_YEARS: 3,
    CUSTOMER_SHOW_PAYIQ_COLUMN: 0,
    CUSTOMER_SHOW_PO_NUMBER_COLUMN: 0,
    CUSTOMER_SHOW_MEMO_COLUMN: 0,
    CUSTOMER_SHOW_PROJECT_ID_COLUMN: 0,
    CUSTOMER_SHOW_ENTITY_COLUMN: 0,
    CUSTOMER_SHOW_MARK_PAID_BUTTON: 0,
    CUSTOMER_SHOW_EXPORT_BUTTON: 1,
    CUSTOMER_SHOW_STATEMENT_BUTTON: 1,
    CUSTOMER_SHOW_EMAIL_BUTTON: 1,
    CUSTOMER_SHOW_NOTES_BUTTON: 1,
    CUSTOMER_SHOW_FILE_UPLOAD: 0,
    CUSTOMER_SHOW_MESSAGE_BOX: 0,
    CUSTOMER_MESSAGE_BOX_TEXT: "",
    CUSTOMER_SHOW_PAYMENT_HISTORY_TAB: 0,
    CUSTOMER_SHOW_QUOTES_AND_PROFORMA: 0,
    CUSTOMER_SHOW_PIE_CHARTS: 1,
    CUSTOMER_SHOW_PAYMENT_PLAN: 0,
    CUSTOMER_SHOW_CREDIT_MANAGEMENT: 0,
    CUSTOMER_SHOW_FAQ: 0,
  },
  statementSettings: {
    STATEMENT_INCLUDE_UNAPPLIED_PAYMENT: 0,
    STATEMENT_INCLUDE_UNAPPLIED_CREDIT_MEMO: 0,
    STATEMENT_ATTACH_INVOICE: 0,
    STATEMENT_SORT_INVOICE_ASC: 0,
    STATEMENT_SHOW_RUNNING_TOTAL: 0,
    STATEMENT_SHOW_CUSTOMER_PO: 0,
    STATEMENT_ATTACH_EXCEL_FILE: 0,
    STATEMENT_ATTACH_PDF_FILE: 0,
    STATEMENT_SHOW_DAYS_PAST_DUE: 0,
    STATEMENT_SHOW_CUSTOMER_NAME: 0,
    STATEMENT_SHOW_REFERENCE: 0,
    STATEMENT_ERP_SYNC: 0,
    STATEMENT_SHOW_MEMO_FIELD: 0,
  },
  invoiceLineSettings: {
    PAYABLES_SHOW_INVOICE_LINE: 0,
    PAYABLES_EDIT_INVOICE_LINE: 0,
    RECEIVABLES_SHOW_INVOICE_LINE: 0,
    RECEIVABLES_EDIT_INVOICE_LINE: 0,
  },
  workflowSettings: {
    ENTITY_LEVEL_WORKFLOW_ENABLED: 0,
    SELECT_HIGH_SEVERITY_WORKFLOW_STEP: 0,
  },
  generalSettings: {
    SHOW_CENTS: 0,
    PUSH_EMAILS_TO_ERP: 0,
    MULTI_FACTOR_AUTHENTICATION_ENABLED: 0,
    CLIENT_VIEW_INVOICE_BUTTON_ENABLED: 1,
  },
  csvSettings: {
    CSV_EMAIL_LIST: "",
    OPEN_REFUNDED_INVOICES_CSV_ENABLED: 0,
  },
  paymentSettings: {
    SYNC_PAYMENT_METHOD_ID: "",
    PAYMENT_NOTIFICATION_TO_ALL_ADMINS: 1,
    PAYMENT_NOTIFICATION_TO_AR_REPS: 0,
    SYNC_PAYMENT_TO_ERP: 0,
    SYNC_DEPOSIT_TO_ERP: 0,
    EARLY_SYNC_ACH_PAYMENT_TO_ERP: 0,
    ENABLE_CHARGE_BASED_PAYMENT: 0,
    PAYMENT_NOTIFICATION_TO_SALES_REP: 0,
  },
  workflowInvoiceSettings: {
    INVOICE_AUTO_ATTACH: 1,
    INVOICE_SHOW_CUSTOMER_PO: 0,
    INVOICE_SHOW_RUNNING_TOTAL: 0,
    INVOICE_SHOW_CUSTOMER_NAME: 0,
    INVOICE_SHOW_DAYS_PAST_DUE: 0,
    INVOICE_SHOW_REFERENCE: 0,
  },
  clientFeatures: {
    CLIENT_EMAIL_SENDER_NAME: "CORP_ENTITY_NAME",
    CLIENT_JOURNAL_SECTION_ENABLED: 1,
    CLIENT_PAYROLL_SECTION_ENABLED: 1,
    CLIENT_VENDORS_SECTION_ENABLED: 1,
    CLIENT_CASHFLOW_SECTION_ENABLED: 1,
    CLIENT_PAYABLES_SECTION_ENABLED: 1,
    CLIENT_CUSTOMERS_SECTION_ENABLED: 1,
    CLIENT_RECEIVABLES_SECTION_ENABLED: 1,
    CLIENT_DISPUTE_AND_DEDUCTION_ENABLED: 0,
    CLIENT_DEDUCTION_ENABLED: 0,
    CLIENT_DISPUTE_WORKFLOW_ENABLED: 0,
    CLIENT_CASHFLOW_BYPAYMENT_ENABLED: 0,
    CLIENT_CASHFLOW_BYINVOICE_ENABLED: 0,
    CLIENT_WORKFLOW_ENABLED: 1,
    CLIENT_PO_ENABLED: 1,
    CLIENT_OB_ENABLED: 1,
    CLIENT_COLLECTOR_GOAL_ENABLED: 0,
    CLIENT_CREDIT_MANAGEMENT_ENABLED: 0,
    CLIENT_COLLECTOR_INBOX_ENABLED: 0,
    CLIENT_COLLECTIONS_ORCHESTRATION_ENGINE_ENABLED: 0,
    AR_REP_MANAGEMENT_ENABLED: 0,
    CLIENT_AI_FEATURES_ENABLED: 0,
    CLIENT_CHATBOT_ENABLED: 0,
  },
  emailListenerSettings: {
    ENABLED: 0,
    EMAIL_HOST: "",
    EMAIL_PORT: "",
    EMAIL_USERNAME: "",
    EMAIL_PASSWORD: "",
    EMAIL_PROTOCOL: "IMAP",
    EMAIL_FOLDER: "INBOX",
    POLLING_INTERVAL: "",
    SSL_ENABLED: 1,
  },
  arAgingBuckets: [],
  apAgingBuckets: [],
  arAgingBucketsSettings: {
    ENTITY_LEVEL_AGING_BUCKET_ENABLED: 0,
    isClientLevelAgingBucketsPresent: false,
  },
};

initialConfigSettings["initialCustomerSettings"] =
  initialConfigSettings["customerSettings"];
initialConfigSettings["initialStatementSettings"] =
  initialConfigSettings["statementSettings"];
initialConfigSettings["initialLineSettings"] =
  initialConfigSettings["invoiceLineSettings"];

const configurableSettings = (
  state = initialConfigSettings,
  { type, payload }
) => {
  switch (type) {
    case ReducersTypes.CONFIG_SETTINGS:
      // eslint-disable-next-line no-case-declarations
      const obj = {};
      Object.keys(payload).forEach((key) => {
        obj[key] = payload[key];
      });
      return {
        ...state,
        ...obj,
      };
    case ReducersTypes.RESET_CONFIG_SETTINGS:
      return initialConfigSettings;
    case ReducersTypes.SET_AR_AGING_BUCKETS_CONFIG:
      return {
        ...state,
        arAgingBucketsSettings: {
          ...state.arAgingBucketsSettings,
          ...payload,
        },
      };
    default:
      return state;
  }
};

const configVariables = (state = {}, { type, payload }) => {
  switch (type) {
    case ReducersTypes.SET_CONFIG_VARIABLES:
      // eslint-disable-next-line no-case-declarations
      const obj = payload.reduce((acc, curr) => {
        // eslint-disable-next-line no-param-reassign
        acc[curr.name] = curr.value;
        return acc;
      }, {});
      return {
        ...state,
        ...obj,
      };
    default:
      return state;
  }
};

const translation = (state = englishTranslation, { type, payload }) => {
  if (type === ReducersTypes.SET_TRANSLATION) {
    return {
      ...state,
      ...payload.translation,
    };
  }
  return state;
};

const globalReducers = {
  ux,
  tag,
  email,
  header,
  applicationAnnouncement,
  preview,
  translation,
  clientDetails,
  confirmationbox,
  workflow_sequence,
  dynamicformReducer,
  payrollSettingsData,
  configurableSettings,
  disputeManagement: disputeReducer,
  configVariables,
};

export default globalReducers;
